
import { defineComponent } from "vue";
import LInfoLinksHome from "@/components/LAsideInfo/LInfoLinksHome.vue";
import LLinksForm from "@/components/form/LLinksForm/LLinksForm.vue";
import LHomeFooter from "@/components/LHomeFooter/LHomeFooter.vue";
import { mapState } from "vuex";

export default defineComponent({
  name: "HomeLinks",
  components: { LInfoLinksHome, LLinksForm, LHomeFooter },
  computed: {
    ...mapState(["isLogin"]),
  },
  mounted() {
    if (!this.isLogin) {
      this.$router.push("/");
    }
  },
});
